import React from 'react';
import { Menu } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

interface TopBarProps {
  title: string;
  onMenuClick: () => void;
  children?: React.ReactNode;
}

export const TopBar: React.FC<TopBarProps> = ({ title, onMenuClick, children }) => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white border-b border-gray-200 px-4 md:px-6 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={onMenuClick}
            className="md:hidden p-1.5 rounded-md hover:bg-gray-100 text-gray-600"
          >
            <Menu className="h-5 w-5" />
          </button>
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          {children}
        </div>

        {user && (
          <div className="flex items-center gap-4 text-sm">
            <span className="text-gray-600 hidden sm:inline">
              {user.name}{' '}
              <span className="text-xs text-gray-400">({user.role})</span>
            </span>
            <button
              onClick={logout}
              className="text-red-600 hover:underline text-sm"
            >
              Sair
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
